import JshModule from '@core/scripts/helper/jsh-module';
import {createRoot} from 'react-dom/client';
import {NewsletterSubscriptionForm} from '@service/scripts/components/contentful/NewsletterSubscriptionForm.jsx';

const {moduleScope, config} = JshModule('service/service-page-newsletter-subscription-form');

createRoot(moduleScope).render(<NewsletterSubscriptionForm cdaEntry={config.model}
                                                           tenantCountry={config.tenantCountry}
                                                           friendlyCaptchaEnabled={config.friendlyCaptchaEnabled}
                                                           friendlyCaptchaSitekeyNewsletter={config.friendlyCaptchaSitekeyNewsletter}
                                                           friendlyCaptchaSitekeyNewsletterAt={config.friendlyCaptchaSitekeyNewsletterAt}
                                                           postValues={config.postValues} />);
